import React from 'react';
import { SecondNoteIcon, TestEyeIcon, TestStartIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

export const InfoSection = () => {
  const t = useTranslations();
  const testInfo = useAppSelector(({ topicTest }) => topicTest.testInfo);

  return (
    <div className="shadow-xs rounded-xl bg-white p-3">
      <div className="inline rounded-md bg-gray-100 px-2 py-1 text-sm">{testInfo?.subject_name}</div>
      <h1 className="text-sm mt-3 font-medium">{testInfo?.lesson_name}</h1>
      <div className="mt-3 hidden justify-between gap-5 rounded-xl bg-gray-50 px-3 py-2 text-xs lg:flex">
        <div className="flex items-center gap-1">
          <TestStartIcon />
          {testInfo?.test_rating}
        </div>
        <div className="flex items-center gap-1">
          <SecondNoteIcon />
          {testInfo?.test_count} {t('test')}
        </div>
        <div className="flex items-center gap-1">
          <TestEyeIcon />
          {testInfo?.view_count}
        </div>
      </div>
    </div>
  );
};
